const initialize = () => {
    $('[data-tab-group-header-button]').click(function() {
        const $group = $(this).parents('[data-tab-group]');
        const $headerItem = $(this).parents('[data-tab-group-header-item]');
        const index = $headerItem.index();
        const $contentItem = (
            $group.find('[data-tab-group-content-item]').eq(index)
        );
        const $activeHeaderItem = (
            $group.find('[data-tab-group-header-item][data-active="1"]')
        );
        const $activeContentItem = (
            $group.find('[data-tab-group-content-item][data-active="1"]')
        );

        $activeHeaderItem.removeAttr('data-active');
        $activeContentItem.removeAttr('data-active');

        gsap.set(
            $activeContentItem,
            {
                clearProps: 'all',
            }
        );

        $headerItem.attr('data-active', '1');
        $contentItem.attr('data-active', '1');

        gsap.fromTo(
            $contentItem,
            {
                opacity: 0,
            },
            {
                display: 'block',
                opacity: 1,
                duration: 0.2,
            }
        );
    });
};

export default {
    initialize,
};

